import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "text_add",
  "use": "text_add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"text_add\"><path d=\"M12 8.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm2 4.25h-1.25V14h-1.5v-1.25H10v-1.5h1.25V10h1.5v1.25H14v1.5zM12.5 1.54V5H14V1.54C14 .69 13.31 0 12.46 0H1.54C.69 0 0 .69 0 1.54V5h1.5V1.54c0-.02.02-.04.04-.04h4.71v11H3V14h4.75V1.5h4.71c.02 0 .04.02.04.04z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol